import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';

import request from 'common/Api';
import { FORMS } from 'common/Constants';
import * as actions from 'common/SearchStore/SearchActions';
import { receiveB2CUserData, setB2CUpdateStatus } from 'common/SearchStore/SearchActions';
import { getB2CUpdateStatus } from 'common/SearchStore/SearchSelectors';
import { base64Encode } from 'utils/strings';
import SearchByUser from './SearchByUser';

const onSubmit = ({ userEmail }, dispatch) => {
  const emailBase64 = base64Encode(userEmail.toLowerCase());
  dispatch(setB2CUpdateStatus(null));
  const requestBody = request({
    method: 'GET',
    url: `/csp/user/${emailBase64}`,
  });

  return dispatch(requestBody)
    .then((authUserData) => {
      const {
        customUserType: userType,
        emailAddress: email,
        givenName: firstName,
        id,
        surname: lastName,
        userPrincipalName,
      } = authUserData?.authData || {};

      if (!userPrincipalName) {
        throw new Error('No results returned.');
      }
      dispatch(
        receiveB2CUserData({
          email,
          firstName,
          id,
          lastName,
          userType,
        }),
      );
      return Promise.resolve();
    })
    .catch((error) => {
      const formError = {
        _error: error?.message,
      };
      const { response } = error;

      switch (response?.status) {
        case 503: {
          formError._error =
            'My Viking Journey is currently down for maintenance and will be back soon. <br /> Please try again later.';
          break;
        }
        case 404: {
          const emailError = 'No account found for this email.';

          formError._error = emailError;
          formError.type = 'status-message';
          break;
        }
        default: {
          formError._error = 'No search results found. <br /> Please try again.';
        }
      }
      return Promise.reject(new SubmissionError(formError));
    });
};

const mapStateToProps = (state) => {
  return {
    b2cUserData: state.search?.b2cUserData,
    b2cUpdateStatus: getB2CUpdateStatus(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearEmailFormData: () => {
    dispatch(actions.receiveB2CUserData(null));
    dispatch(setB2CUpdateStatus(null));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORMS.SEARCH_BY_USER,
    onSubmit,
  }),
)(SearchByUser);
